// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: theme.palette.primary.green,
            borderColor: theme.palette.primary.green,
            ...theme.applyStyles('dark', { color: theme.palette.primary.green }),
            '& .MuiListItemIcon-root': {
              color: theme.palette.primary.darkGreen,
            },
            '& .MuiTypography-root': {
              color: theme.palette.primary.darkGreen,
              fontWeight: '700',
            }
          }
        }
      }
    }
  };
}
